import { Component, ChangeDetectorRef, Inject } from '@angular/core';
import { DialogComponentBase } from '@wephone-core-ui';
import { _tk } from 'jsphonelib/translation';
import { DialogActionButton, Colors, localNow, parseDateTime } from '@wephone-utils';
import { ConfigManager } from '@wephone-core/wephone-core.module';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CrmContactService } from '@wephone-core/service/crm-contact.service';
import { DateTime } from 'luxon';
import { _ti } from '@wephone-translation';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-crm-create-task-modal',
  templateUrl: './crm-create-task-modal.component.html',
  styleUrls: ['./crm-create-task-modal.component.scss']
})
export class CrmCreateTaskModalComponent extends DialogComponentBase {
  dialogTitle = _tk('crm.create_task.title');
  dialogRightActions: DialogActionButton[] = [
    {
      label: _tk('public.apply'),
      action: () => {
        this.submit();
      },
      visible: () => {
        return true;
      },
      color: Colors.PRIMARY
    }
  ];

  task = {
    subject: '',
    body: '',
    dueDate: localNow().toJSDate(),
    atDt: '09:00',
  };

  constructor(
    cdr: ChangeDetectorRef,
    public configManager: ConfigManager,
    dialogRef: MatDialogRef<CrmCreateTaskModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly crmContactService: CrmContactService,
    dateAdapter: DateAdapter<Date>,
  ) {
    super(dialogRef, cdr);
    this.dateAdapter = dateAdapter;
  }

  async submit(): Promise<any> {
    let timestamp = null;

    if (this.task.dueDate && parseDateTime(this.task.dueDate)) {
      timestamp = DateTime.fromSQL(`${parseDateTime(this.task.dueDate).toISODate()} ${this.task.atDt}:00`).valueOf();
    }

    const data = {
      crmId: this.data.crmId,
      contactId: this.data.contactId,
      subject: this.task.subject,
      body: this.task.body,
      timestamp,
      contactType: this.data.contactType,
      phoneNumber: this.data.phoneNumber,
    };

    try {
      await this.crmContactService.createTask(data);
      this.toastService.showSuccess(_ti('public.message.create_success'));
      this.dismiss();
    } catch (error) {
      this.toastService.showError(_ti(error.message));
    }
  }
}
